import React from 'react';

const TableWidget = ({ table, isResizable = false }) => {
  if (!table?.headers || !table?.rows) {
    return <div className="text-gray-500 p-4">No table data available</div>;
  }
  return (
    <div className={`overflow-x-auto ${isResizable ? 'h-full' : 'max-h-64'} overflow-y-auto`}>
      <table className="min-w-full divide-y divide-gray-200 text-sm">
        <thead className="bg-gray-50 sticky top-0">
          <tr>
            {table.headers.map((header, idx) => (
              <th key={idx} className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                {header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
          {table.rows.map((row, rowIdx) => (
            <tr key={rowIdx} className={rowIdx % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
              {row.map((cell, cellIdx) => (
                <td key={cellIdx} className="px-3 py-2 whitespace-nowrap text-gray-900">{cell}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default TableWidget;